import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getProductCategories = async () => {
  const response = await axios.get(`${base_url}category/all`, getAuthHeaders());

  return response.data;
};
// const createCategory = async (category) => {
//   const response = await axios.post(`${base_url}category/add`, category, config);

//   return response.data;
// };

// const createCategory = async (category) => {
//   const response = await axios.post(
//     `${base_url}category/add`,
//     {
//       category_name: category.category_name,
//       category_image: category.category_image, // Base64 image string
//     },
//     config
//   );

//   return response.data;
// };

const createCategory = async (category) => {
  const token = getToken();
  const response = await axios.post(
    `${base_url}category/add`,
    category, // `category` is already a FormData object
    {
      headers: {
        "Content-Type": "multipart/form-data", // ✅ Required for FormData
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};


const getProductCategory = async (id) => {
  const response = await axios.get(`${base_url}category/get/${id}`, getAuthHeaders());

  return response.data;
};

const deleteProductCategory = async (id) => {
  const response = await axios.delete(`${base_url}category/delete/${id}`, getAuthHeaders());

  return response.data;
};
// const updateProductCategory = async (category) => {
//   console.log(category);
//   console.log(`${base_url}category/edit/${category.id}`)
//   const response = await axios.put(
//     `${base_url}category/edit/${category.id}`,
//     { category_name: category.pCatData.category_name },
//     config
//   );
//   return response.data;
// };

// const updateProductCategory = async (category) => {
//   const formData = new FormData();
//   formData.append("category_name", category.pCatData.category_name);

//   // Check if `category_image` is a file or a string (existing image path)
//   if (category.pCatData.category_image instanceof File) {
//     formData.append("category_image", category.pCatData.category_image); // Append file
//   } else {
//     formData.append("category_image", category.pCatData.category_image); // Append existing path
//   }

//   const response = await axios.put(
//     `${base_url}category/edit/${category.id}`,
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Required for FormData
//       },
//     }
//   );

//   return response.data;
// };


// const updateProductCategory = async (category) => {
//   const response = await axios.put(
//     `${base_url}category/edit/${category.id}`,
//     {
//       category_name: category.pCatData.category_name,
//       category_image: category.pCatData.category_image, // Base64 image string
//     },
//     config
//   );
//   return response.data;
// };

const updateProductCategory = async (category) => {
  const token = getToken();
  const response = await axios.put(
    `${base_url}category/edit/${category.id}`,
    category.pCatData, // Ensure this is FormData
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};


// const updateProductCategory = async (category) => {
//   const response = await axios.put(
//     `${base_url}category/edit/${category.id}`,
//     category.pCatData, // FormData object
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Required for FormData
//       },
//     }
//   );
//   return response.data;
// };

// const updateProductCategory = async (category) => {
//   const response = await axios.put(
//     `${base_url}category/edit/${category.id}`,
//     category.pCatData, 
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Ensure FormData is sent
//       },
//     }
//   );
//   return response.data;
// };

const pCategoryService = {
  getProductCategories,
  createCategory,
  getProductCategory,
  deleteProductCategory,
  updateProductCategory,
};

export default pCategoryService;
